export const adjustments = [
  {
    id: 'adj_001',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_003',
    contractNumber: 'CTR-2025-018',
    clientId: 'cli_alpha',
    clientName: 'Studio Alpha',
    indexId: 'idx_ipca',
    indexCode: 'IPCA',
    referencePeriod: '2025',
    indexRate: 4.18,
    previousValue: 4800,
    newValue: 5000.64,
    appliedAt: '01/03/2026',
    status: 'Aplicado',
    notes: 'Reajuste anual conforme cláusula 8.2.',
  },
  {
    id: 'adj_002',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_001',
    contractNumber: 'CTR-2026-001',
    clientId: 'cli_xpto',
    clientName: 'XPTO Tecnologia',
    indexId: 'idx_igpm',
    indexCode: 'IGP-M',
    referencePeriod: '2026',
    indexRate: 4.52,
    previousValue: 2995,
    newValue: 3130.37,
    appliedAt: '01/01/2027',
    status: 'Pendente',
    notes: 'Próximo reajuste programado.',
  },
  {
    id: 'adj_003',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_004',
    contractNumber: 'CTR-2026-003',
    clientId: 'cli_horizonte',
    clientName: 'Horizonte',
    indexId: 'idx_igpm',
    indexCode: 'IGP-M',
    referencePeriod: '2026/1',
    indexRate: 2.15,
    previousValue: 8400,
    newValue: 8580.6,
    appliedAt: '01/12/2026',
    status: 'Pendente',
    notes: 'Reajuste semestral previsto.',
  },
  {
    id: 'adj_004',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_002',
    contractNumber: 'CTR-2026-002',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft',
    indexId: 'idx_ipca',
    indexCode: 'IPCA',
    referencePeriod: '2025',
    indexRate: 4.18,
    previousValue: 9900,
    newValue: 10313.82,
    appliedAt: '15/02/2026',
    status: 'Aplicado',
    notes: 'Reajuste na renovação do contrato.',
  },
  {
    id: 'adj_005',
    organizationId: 'org_3la_labs',
    contractId: 'ctr_005',
    contractNumber: 'CTR-2026-004',
    clientId: 'cli_norte',
    clientName: 'Norte Digital',
    indexId: 'idx_fixo',
    indexCode: 'FIXO',
    referencePeriod: '2026',
    indexRate: 5,
    previousValue: 900,
    newValue: 945,
    appliedAt: '01/04/2027',
    status: 'Cancelado',
    notes: 'Cancelado — contrato suspenso.',
  },
];
